"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dialogSurfaceClassNames: function() {
        return dialogSurfaceClassNames;
    },
    useDialogSurfaceStyles_unstable: function() {
        return useDialogSurfaceStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reacttheme = require("@fluentui/react-theme");
const dialogSurfaceClassNames = {
    root: 'fui-DialogSurface',
    backdrop: 'fui-DialogSurface__backdrop'
};
/**
 * Styles for the root slot
 */ const useRootBaseStyle = /*#__PURE__*/ (0, _react.__resetStyles)("rhhzfde", "r1n1tr5u", {
    r: [
        ".rhhzfde{top:0;right:0;bottom:0;left:0;padding-top:24px;padding-right:24px;padding-bottom:24px;padding-left:24px;margin-top:auto;margin-right:auto;margin-bottom:auto;margin-left:auto;border-top-style:solid;border-right-style:solid;border-bottom-style:solid;border-left-style:solid;overflow-x:unset;overflow-y:unset;border-top-width:1px;border-right-width:1px;border-bottom-width:1px;border-left-width:1px;border-top-color:var(--colorTransparentStroke);border-right-color:var(--colorTransparentStroke);border-bottom-color:var(--colorTransparentStroke);border-left-color:var(--colorTransparentStroke);border-bottom-right-radius:var(--borderRadiusXLarge);border-bottom-left-radius:var(--borderRadiusXLarge);border-top-right-radius:var(--borderRadiusXLarge);border-top-left-radius:var(--borderRadiusXLarge);display:block;-webkit-user-select:unset;-moz-user-select:unset;-ms-user-select:unset;user-select:unset;visibility:unset;position:fixed;height:fit-content;max-width:600px;max-height:100vh;box-sizing:border-box;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);}",
        ".rhhzfde:focus{outline-style:none;}",
        ".rhhzfde:focus-visible{outline-style:none;}",
        ".rhhzfde[data-fui-focus-visible]{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",
        ".rhhzfde[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border-top-style:solid;border-right-style:solid;border-bottom-style:solid;border-left-style:solid;border-top-width:2px;border-right-width:2px;border-bottom-width:2px;border-left-width:2px;border-bottom-right-radius:var(--borderRadiusMedium);border-bottom-left-radius:var(--borderRadiusMedium);border-top-right-radius:var(--borderRadiusMedium);border-top-left-radius:var(--borderRadiusMedium);border-top-color:var(--colorStrokeFocus2);border-right-color:var(--colorStrokeFocus2);border-bottom-color:var(--colorStrokeFocus2);border-left-color:var(--colorStrokeFocus2);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}",
        ".r1n1tr5u{top:0;left:0;bottom:0;right:0;padding-top:24px;padding-left:24px;padding-bottom:24px;padding-right:24px;margin-top:auto;margin-left:auto;margin-bottom:auto;margin-right:auto;border-top-style:solid;border-left-style:solid;border-bottom-style:solid;border-right-style:solid;overflow-x:unset;overflow-y:unset;border-top-width:1px;border-left-width:1px;border-bottom-width:1px;border-right-width:1px;border-top-color:var(--colorTransparentStroke);border-left-color:var(--colorTransparentStroke);border-bottom-color:var(--colorTransparentStroke);border-right-color:var(--colorTransparentStroke);border-bottom-left-radius:var(--borderRadiusXLarge);border-bottom-right-radius:var(--borderRadiusXLarge);border-top-left-radius:var(--borderRadiusXLarge);border-top-right-radius:var(--borderRadiusXLarge);display:block;-webkit-user-select:unset;-moz-user-select:unset;-ms-user-select:unset;user-select:unset;visibility:unset;position:fixed;height:fit-content;max-width:600px;max-height:100vh;box-sizing:border-box;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);}",
        ".r1n1tr5u:focus{outline-style:none;}",
        ".r1n1tr5u:focus-visible{outline-style:none;}",
        ".r1n1tr5u[data-fui-focus-visible]{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",
        ".r1n1tr5u[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border-top-style:solid;border-left-style:solid;border-bottom-style:solid;border-right-style:solid;border-top-width:2px;border-left-width:2px;border-bottom-width:2px;border-right-width:2px;border-bottom-left-radius:var(--borderRadiusMedium);border-bottom-right-radius:var(--borderRadiusMedium);border-top-left-radius:var(--borderRadiusMedium);border-top-right-radius:var(--borderRadiusMedium);border-top-color:var(--colorStrokeFocus2);border-left-color:var(--colorStrokeFocus2);border-bottom-color:var(--colorStrokeFocus2);border-right-color:var(--colorStrokeFocus2);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}"
    ],
    s: [
        "@media (forced-colors: active){.rhhzfde[data-fui-focus-visible]::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}",
        "@media screen and (max-width: 480px){.rhhzfde{max-width:100vw;}}",
        "@media (forced-colors: active){.r1n1tr5u[data-fui-focus-visible]::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}",
        "@media screen and (max-width: 480px){.r1n1tr5u{max-width:100vw;}}"
    ]
});
const rootVisible = {
    boxShadow: _reacttheme.tokens.shadow64,
    transform: 'scale(1) translateZ(0)',
    opacity: 1
};
const rootWhenAnimating = {
    transitionDuration: _reacttheme.tokens.durationGentle,
    transitionProperty: 'opacity, transform, box-shadow',
    // // FIXME: https://github.com/microsoft/fluentui/issues/29473
    transitionTimingFunction: _reacttheme.tokens.curveDecelerateMid
};
const useRootStyles = /*#__PURE__*/ (0, _react.__styles)({
    animated: {
        abs64n: "fk73vx1",
        E5pizo: "f1yzz98r",
        Bz10aip: "f15ofi6c"
    },
    "static": {
        E5pizo: "f10nrhrw"
    },
    unmounted: {},
    entering: {
        B3o57yi: "fc397y7",
        Bmy1vo4: "f1b86uth",
        Bkqvd7p: "f18ad807",
        E5pizo: "f10nrhrw",
        Bz10aip: "f186d0ee",
        abs64n: "f5p0z4x"
    },
    entered: {
        E5pizo: "f10nrhrw",
        Bz10aip: "f186d0ee",
        abs64n: "f5p0z4x"
    },
    idle: {
        E5pizo: "f10nrhrw",
        Bz10aip: "f186d0ee",
        abs64n: "f5p0z4x"
    },
    exiting: {
        B3o57yi: "fc397y7",
        Bmy1vo4: "f1b86uth",
        Bkqvd7p: "f1mfizis"
    },
    exited: {}
}, {
    d: [
        ".fk73vx1{opacity:0;}",
        ".f1yzz98r{box-shadow:0px 0px 0px 0px rgba(0, 0, 0, 0.1);}",
        ".f15ofi6c{transform:scale(0.85) translateZ(0);}",
        ".f10nrhrw{box-shadow:var(--shadow64);}",
        ".fc397y7{transition-duration:var(--durationGentle);}",
        ".f1b86uth{transition-property:opacity,transform,box-shadow;}",
        ".f18ad807{transition-timing-function:var(--curveDecelerateMid);}",
        ".f186d0ee{transform:scale(1) translateZ(0);}",
        ".f5p0z4x{opacity:1;}",
        ".f1mfizis{transition-timing-function:var(--curveAccelerateMin);}"
    ]
});
/**
 * Styles for the backdrop slot
 */ const backdropVisible = {
    opacity: 1
};
const useBackdropBaseStyle = /*#__PURE__*/ (0, _react.__resetStyles)("raidwwn", "r17vltcu", [
    ".raidwwn{top:0px;right:0px;bottom:0px;left:0px;background-color:rgba(0, 0, 0, 0.4);position:fixed;transition-duration:var(--durationGentle);transition-timing-function:var(--curveLinear);transition-property:opacity;will-change:opacity;opacity:0;}",
    ".r17vltcu{top:0px;left:0px;bottom:0px;right:0px;background-color:rgba(0, 0, 0, 0.4);position:fixed;transition-duration:var(--durationGentle);transition-timing-function:var(--curveLinear);transition-property:opacity;will-change:opacity;opacity:0;}"
]);
const useBackdropStyles = /*#__PURE__*/ (0, _react.__styles)({
    nestedDialogBackdrop: {
        De3pzq: "f1c21dwh"
    },
    unmounted: {},
    entering: {
        abs64n: "f5p0z4x"
    },
    entered: {
        abs64n: "f5p0z4x"
    },
    idle: {
        abs64n: "f5p0z4x"
    },
    exiting: {
        Bkqvd7p: "f1mfizis"
    },
    exited: {}
}, {
    d: [
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f5p0z4x{opacity:1;}",
        ".f1mfizis{transition-timing-function:var(--curveAccelerateMin);}"
    ]
});
const useDialogSurfaceStyles_unstable = (state)=>{
    const { isNestedDialog, root, backdrop, transitionStatus } = state;
    const rootBaseStyle = useRootBaseStyle();
    const rootStyles = useRootStyles();
    const backdropBaseStyle = useBackdropBaseStyle();
    const backdropStyles = useBackdropStyles();
    root.className = (0, _react.mergeClasses)(dialogSurfaceClassNames.root, rootBaseStyle, transitionStatus ? rootStyles.animated : rootStyles.static, transitionStatus && rootStyles[transitionStatus], root.className);
    if (backdrop) {
        backdrop.className = (0, _react.mergeClasses)(dialogSurfaceClassNames.backdrop, backdropBaseStyle, isNestedDialog && backdropStyles.nestedDialogBackdrop, transitionStatus && backdropStyles[transitionStatus], backdrop.className);
    }
    return state;
}; //# sourceMappingURL=useDialogSurfaceStyles.styles.js.map
